import { Checkbox, type CheckboxProps } from "@repo/skapa";

import { VisuallyHidden } from "../VisuallyHidden";

export type ListViewItemWithActionsCheckboxProps = CheckboxProps;

export const ListViewItemWithActionsCheckbox = ({
  label,
  id,
  ...props
}: ListViewItemWithActionsCheckboxProps) => {
  return (
    <>
      <VisuallyHidden htmlFor={id} tagName="label">
        {label}
      </VisuallyHidden>
      <Checkbox id={id} {...props} />
    </>
  );
};
